/* eslint-disable no-console */

/**
 * Logger utility pour contrôler les logs en production
 * En production, les logs sont complètement désactivés
 */

const isDevelopment = process.env.NODE_ENV === 'development' || process.env.REACT_APP_DEBUG === 'true';

export const logger = {
  log: (...args) => {
    if (isDevelopment) {
      //console.log(...args);
    }
  },

  error: (...args) => {
    if (isDevelopment) {
     // console.error(...args);
    }
  },

  warn: (...args) => {
    if (isDevelopment) {
     // console.warn(...args);
    }
  },

  info: (...args) => {
    if (isDevelopment) {
     // console.info(...args);
    }
  },

  debug: (...args) => {
    if (isDevelopment) {
     // console.debug(...args);
    }
  },

  // Désactiver completement les logs en production
  enableAll: () => {
    if (isDevelopment) {
      //console.log('🔍 Mode debug activé');
    }
  },

  disableAll: () => {
    if (isDevelopment) {
     // console.log('🔇 Tous les logs vont être désactivés');
    }
  }
};

export default logger;
